import request from "./request";

const api = {
  getSession: "chat/getSession",
  getMessages: "chat/getMessages",
  sendMessage: "chat/sendMessage",
  read: "chat/read",
  getUnread: "chat/getUnread",
  close: "chat/close",
  recall: "chat/recall",
};

export default {
  /** 获取/创建当前用户的会话 */
  getSession(parameter) {
    return request({
      url: api.getSession,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 历史消息（page/size 分页 或 before_id 游标 / after_id 增量） */
  getMessages(parameter) {
    return request({
      url: api.getMessages,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 发送消息（WS 断开时的兜底通道） */
  sendMessage(parameter) {
    return request({
      url: api.sendMessage,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 上报已读（read_id 省略时视为读到最新一条） */
  read(parameter) {
    return request({
      url: api.read,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 未读数 */
  getUnread(parameter) {
    return request({
      url: api.getUnread,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 用户主动结束会话（下次发言自动重开） */
  close(parameter) {
    return request({
      url: api.close,
      method: "POST",
      data: parameter || {},
    });
  },
  /** 撤回消息（仅本人 2 分钟内） */
  recall(parameter) {
    return request({
      url: api.recall,
      method: "POST",
      data: parameter || {},
    });
  },
};
